import React, { useMemo, useState } from 'react';
import { ButtonBase, Menu, MenuItem } from '@mui/material';

const googleMapsUrl = (location) => {
  const query = location.place_id
    ? (location.address || location.name)
    :location.address;
  const params = new URLSearchParams({ api: '1', query });
  if (location.place_id) params.set('query_place_id', location.place_id);
  return `https://www.google.com/maps/search/?${params.toString()}`;
};

const appleMapsUrl = (location) => {
  const params = new URLSearchParams();
  if (location.latitude != null && location.longitude != null) {
    params.set('coordinate', `${location.latitude},${location.longitude}`);
  }
  if (location.address) params.set('address', location.address);
  return `https://maps.apple.com/place?${params.toString()}`;
};

export default function MapAddressLink({ location }) {
  const [anchor, setAnchor] = useState(null);
  const links = useMemo(() => (
    location?.address
      ? { google: googleMapsUrl(location), apple: appleMapsUrl(location) }
      : { google: '', apple: '' }
  ), [location]);

  if (!location?.address) return null;

  const close = () => setAnchor(null);

  return (
    <>
      <ButtonBase
        type="button"
        aria-label={`Open ${location.address} in maps`}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchor)}
        onClick={(clickEvent) => setAnchor(clickEvent.currentTarget)}
        sx={{
          color: 'secondary.main',
          font: 'inherit',
          textAlign: 'left',
          textDecoration: 'underline',
          textUnderlineOffset: '3px',
          overflowWrap: 'anywhere',
        }}
      >
        {location.address}
      </ButtonBase>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={close}
        MenuListProps={{ 'aria-label': `Open ${location.address} with` }}
      >
        <MenuItem
          component="a"
          href={links.google}
          target="_blank"
          rel="noopener noreferrer"
          onClick={close}
        >
          Google Maps
        </MenuItem>
        <MenuItem
          component="a"
          href={links.apple}
          target="_blank"
          rel="noopener noreferrer"
          onClick={close}
        >
          Apple Maps
        </MenuItem>
      </Menu>
    </>
  );
}
